// import React, { useEffect, useState } from "react";
// import banner from "../../Assets/Banner/Metal.png";
// import ProductFilterSection from "../../components/common/ProductFilterSection";
// import axios from "axios";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import { useLocation } from "react-router-dom";
// import { useTranslation } from "react-i18next";

// const AllProduct = () => {
//   const [allProducts, setAllProducts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [originalProducts, setOriginalProducts] = useState([]);
//   const location = useLocation();
//   const q = new URLSearchParams(location.search).get("search");
//   const { t, i18n } = useTranslation();
//   const currentLanguage = i18n.language || "en";

//   useEffect(() => {
//     AOS.init({ duration: 800, once: true });
//     window.scrollTo({ top: 0, behavior: "smooth" });
//     fetchProducts();
//   }, [q]);

//   // Helper function to get localized text
//   const getLocalizedText = (item, field) => {
//     if (!item || !item[field]) return "";
    
//     // If value is a string (backward compatibility)
//     if (typeof item[field] === 'string') {
//       return item[field];
//     }
    
//     // If value is an object with language keys
//     if (typeof item[field] === 'object') {
//       return item[field][currentLanguage] || 
//              item[field].en || 
//              item[field].hi || 
//              item[field].es || 
//              item[field].zh || 
//              "";
//     }
    
//     return "";
//   };

//   const fetchProducts = async () => {
//     try {
//       setLoading(true);
//       const res = await axios.get(
//         `${process.env.REACT_APP_API_URL}/products/get-all-products`
//       );
//       const products = res.data?.products || [];

//       // Add localized name to each product for search functionality
//       const productsWithLocalizedNames = products.map(product => ({
//         ...product,
//         localizedName: getLocalizedText(product, "name")
//       }));

//       setOriginalProducts(productsWithLocalizedNames);
      
//       let finalList = productsWithLocalizedNames;
//       if (q) {
//         const searchLower = q.toLowerCase();
//         finalList = productsWithLocalizedNames.filter((p) => {
//           // Check localized name for search
//           const productName = (p.localizedName || "").toLowerCase();
//           return productName.includes(searchLower);
//         });
//       }

//       setAllProducts(finalList);
//     } catch (error) {
//       console.error("Error fetching products:", error);
//       setAllProducts([]);
//       setOriginalProducts([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Update products when language changes
//   useEffect(() => {
//     if (originalProducts.length > 0) {
//       const updatedProducts = originalProducts.map(product => ({
//         ...product,
//         localizedName: getLocalizedText(product, "name")
//       }));
      
//       setOriginalProducts(updatedProducts);
      
//       let finalList = updatedProducts;
//       if (q) {
//         const searchLower = q.toLowerCase();
//         finalList = updatedProducts.filter((p) => {
//           const productName = (p.localizedName || "").toLowerCase();
//           return productName.includes(searchLower);
//         });
//       }
      
//       setAllProducts(finalList);
//     }
//   }, [currentLanguage]);

//   return (
//     <div>
//       {/* TOP BANNER */}
//       <div className="w-full">
//         <img 
//           src={banner} 
//           alt={t("all_products.banner_alt") || "Products Banner"} 
//           className="w-full h-auto object-cover" 
//         />
//       </div>

//       {/* SEARCH TITLE */}
//       {q && (
//         <div className="px-4 md:px-10 py-4 bg-gray-50 border-b">
//           <p className="text-gray-600 text-sm">
//             {t("all_products.search_results") || "Search results for:"}{" "}
//             <span className="font-semibold text-gray-900">"{q}"</span>
//           </p>
//           <p className="text-sm text-gray-500 mt-1">
//             {allProducts.length} {t("all_products.products_found") || "products found"}
//           </p>
//         </div>
//       )}

//       {/* SHOW ALL PRODUCTS + FILTER + WISHLIST + ADD TO CART */}
//       <ProductFilterSection 
//         products={allProducts} 
//         loading={loading}
//         searchQuery={q}
//       />
//     </div>
//   );
// };

// export default AllProduct;


import React, { useEffect, useState } from "react";
import banner from "../../Assets/Banner/Metal.png";
import ProductFilterSection from "../../components/common/ProductFilterSection";
import axios from "axios";
import AOS from "aos";
import "aos/dist/aos.css";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const AllProduct = () => {
  const [allProducts, setAllProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [originalProducts, setOriginalProducts] = useState([]);
  const location = useLocation();
  const q = new URLSearchParams(location.search).get("search");
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language || "en";

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
    window.scrollTo({ top: 0, behavior: "smooth" });
    fetchProducts();
  }, [q]);

  // Helper function to get localized text
  const getLocalizedText = (item, field) => {
    if (!item || !item[field]) return "";
    
    if (typeof item[field] === 'string') {
      return item[field];
    }
    
    if (typeof item[field] === 'object') {
      return item[field][currentLanguage] || 
             item[field].en || 
             item[field].hi || 
             item[field].es || 
             item[field].zh || 
             "";
    }
    
    return "";
  };

  const fetchProducts = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/products/get-all-products`
      );
      const products = res.data?.products || [];

      // Add localized name to each product for search functionality
      const productsWithLocalizedNames = products.map(product => ({
        ...product,
        localizedName: getLocalizedText(product, "name")
      }));

      setOriginalProducts(productsWithLocalizedNames);
      
      let finalList = productsWithLocalizedNames;
      if (q) {
        const searchLower = q.toLowerCase();
        finalList = productsWithLocalizedNames.filter((p) => {
          const productName = (p.localizedName || "").toLowerCase();
          return productName.includes(searchLower);
        });
      }

      setAllProducts(finalList);
    } catch (error) {
      console.error("Error fetching products:", error);
      setAllProducts([]);
      setOriginalProducts([]);
    } finally {
      setLoading(false);
    }
  };

  // Update products when language changes
  useEffect(() => {
    if (originalProducts.length > 0) {
      const updatedProducts = originalProducts.map(product => ({
        ...product,
        localizedName: getLocalizedText(product, "name")
      }));
      
      setOriginalProducts(updatedProducts);
      
      let finalList = updatedProducts;
      if (q) {
        const searchLower = q.toLowerCase();
        finalList = updatedProducts.filter((p) => {
          const productName = (p.localizedName || "").toLowerCase();
          return productName.includes(searchLower);
        });
      }
      
      setAllProducts(finalList);
    }
  }, [currentLanguage]);

  return (
    <div>
      {/* TOP BANNER */}
      <div className="w-full">
        <img 
          src={banner} 
          alt={t("all_products.banner_alt") || "Products Banner"} 
          className="w-full h-auto object-cover" 
        />
      </div>

      {/* SEARCH TITLE */}
      {q && (
        <div className="px-4 md:px-10 py-4 bg-gray-50 border-b">
          <p className="text-gray-600 text-sm">
            {t("all_products.search_results") || "Search results for:"}{" "}
            <span className="font-semibold text-gray-900">"{q}"</span>
          </p>
          <p className="text-sm text-gray-500 mt-1">
            {allProducts.length} {t("all_products.products_found") || "products found"}
          </p>
        </div>
      )}

      {/* SHOW ALL PRODUCTS + FILTER + WISHLIST + ADD TO CART */}
      <ProductFilterSection 
        products={allProducts} 
        loading={loading}
        searchQuery={q}
      />
    </div>
  );
};

export default AllProduct;